import { useState } from "react";
import { getDemoState, getResponse, numberOfResponses } from "./Training.mocks";

export const useMockResponse = () => {
  const [responseIndex, setResponseIndex] = useState(0);
  const response = getResponse(responseIndex);

  const toggleResponse = () =>
    setResponseIndex((previous) => (previous + 1) % numberOfResponses);

  const demoBreadcrumb = {
    id: "demo-state",
    label: getDemoState(responseIndex),
    chip: "DEMO",
    onClick: toggleResponse,
  };

  return {
    response,
    demoBreadcrumb,
  };
};
